import { api } from '@/services/api'

export default class PracticeResource {
    async getPracticeList(startDate, endDate, filters) {
        try {
            const body = {
                dateStart: startDate,
                dateEnd: endDate,
            }
            if (filters.region) body.region = filters.region
            if (filters.mmm) body.mmm = filters.mmm
            if (filters.phn) body.phn = filters.phn
            return await api.post('svplanner/get_practices/', body)
        } catch (e) {
            console.log('error', e)
            return []
        }
    }

    async getPracticeAndSurveyors(startDate, endDate, filters) {
        try {
            const body = {
                dateStart: startDate,
                dateEnd: endDate,
            }
            if (filters.region) body.region = filters.region
            if (filters.mmm) body.mmm = filters.mmm
            if (filters.phn) body.phn = filters.phn
            if (filters.practiceIds) body.practiceIds = filters.practiceIds
            return await api.post('svplanner/get_practices_and_surveyors/', body)
        } catch (e) {
            console.log('error', e)
            return []
        }
    }
}
